var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFillesImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6496_24133)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6496_24133",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 400,
    height: 400
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M400 0H0V400H400V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6496_24133)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M294.334 313.665C294.334 317.348 291.349 320.332 287.667 320.332C283.984 320.332 281 317.348 281 313.665C281 309.983 283.984 307 287.667 307C291.349 307 294.334 309.983 294.334 313.665Z",
    stroke: "#0EE171",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.332 130.666C63.332 134.349 60.346 137.334 56.664 137.334C52.982 137.334 49.998 134.349 49.998 130.666C49.998 126.984 52.982 124 56.664 124C60.346 124 63.332 126.984 63.332 130.666Z",
    stroke: "#0EE171",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.332 310.666C113.332 314.349 110.346 317.334 106.664 317.334C102.982 317.334 99.998 314.349 99.998 310.666C99.998 306.984 102.982 304 106.664 304C110.346 304 113.332 306.984 113.332 310.666Z",
    stroke: "#93F145",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5269 271.914L55.9129 275.529C54.4189 277.023 51.9949 277.023 50.4999 275.529L46.8869 271.914C45.3919 270.419 45.3919 267.997 46.8869 266.502L50.4999 262.888C51.9949 261.394 54.4189 261.394 55.9129 262.888L59.5269 266.502C61.0219 267.997 61.0219 270.419 59.5269 271.914Z",
    fill: "#F1EC48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6927 258.934H52.7227V251.25H53.6927V258.934Z",
    fill: "#F1EC48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6927 287.164H52.7227V279.48H53.6927V287.164Z",
    fill: "#F1EC48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1645 269.693H63.4805V268.721H71.1645V269.693Z",
    fill: "#F1EC48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.934 269.693H35.25V268.721H42.934V269.693Z",
    fill: "#F1EC48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.529 154.914L354.916 158.528C353.422 160.023 350.998 160.023 349.503 158.528L345.889 154.914C344.394 153.419 344.394 150.997 345.889 149.502L349.503 145.888C350.998 144.394 353.422 144.394 354.916 145.888L358.529 149.502C360.024 150.997 360.024 153.419 358.529 154.914Z",
    fill: "#F1EC48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.693 141.934H351.723V134.25H352.693V141.934Z",
    fill: "#F1EC48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.693 170.164H351.723V162.48H352.693V170.164Z",
    fill: "#F1EC48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.164 152.693H362.48V151.723H370.164V152.693Z",
    fill: "#F1EC48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.934 152.693H334.25V151.723H341.934V152.693Z",
    fill: "#F1EC48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.1402 101.423L83.5567 108.49L81.5788 109.727L77.1625 102.659L79.1402 101.423Z",
    fill: "#00A656"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4436 108.772L84.5114 104.355L83.2758 102.376L76.208 106.793L77.4436 108.772Z",
    fill: "#00A656"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.14595
  }, /*#__PURE__*/React.createElement("path", {
    d: "M325.179 301.485L320.143 294.846L322.001 293.435L327.037 300.076L325.179 301.485Z",
    fill: "#00A656"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.205 294.013L319.565 299.05L320.974 300.909L327.614 295.872L326.205 294.013Z",
    fill: "#00A656"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M380.64 186.423L385.056 193.491L383.079 194.727L378.662 187.66L380.64 186.423Z",
    fill: "#00A656"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.944 193.772L386.011 189.356L384.775 187.378L377.708 191.793L378.944 193.772Z",
    fill: "#00A656"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6402 159.423L29.0567 166.49L27.0769 167.726L22.6625 160.659L24.6402 159.423Z",
    fill: "#00A656"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9436 166.772L30.0114 162.355L28.7739 160.376L21.708 164.793L22.9436 166.772Z",
    fill: "#00A656"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.763966
  }, /*#__PURE__*/React.createElement("path", {
    d: "M318.367 116.92L326.589 115.558L326.969 117.859L318.749 119.222L318.367 116.92Z",
    fill: "#00A656"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.5 121.31L323.138 113.088L320.836 113.47L322.199 121.69L324.5 121.31Z",
    fill: "#00A656"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M317.545 188.51C323.794 253.548 276.137 311.337 211.098 317.586C146.061 323.835 88.2729 276.177 82.024 211.14C75.775 146.102 123.431 88.3113 188.469 82.0623C253.507 75.8132 311.296 123.473 317.545 188.51Z",
    stroke: "#00A656",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeDasharray: "5.99 5.99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.65 248.219H157.5V152.719H223.15L235.65 165.294V248.219Z",
    fill: "#00A656"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.65 248.219H157.5V152.719H223.15L235.65 165.294V248.219Z",
    stroke: "#00A656",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.65 234.795H172.816V134.795H230.983L230.65 158.795H254.65V234.795Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.65 234.795H172.816V134.795H230.983L230.65 158.795H254.65V234.795Z",
    stroke: "#00A656",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.377 134.5L255.073 158.326",
    stroke: "#00A656",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.984 181.295H185.65V176.961H239.984V181.295Z",
    fill: "#00A656"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.984 194.627H185.65V190.293H239.984V194.627Z",
    fill: "#00A656"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.984 207.961H185.65V203.627H239.984V207.961Z",
    fill: "#00A656"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.316 163.461H185.65V144.795H204.316V163.461Z",
    fill: "#00A656"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.666 200.842C128.666 212.658 119.088 222.237 107.272 222.237H55.385C43.578 222.237 34 212.658 34 200.842C34 189.027 43.578 179.457 55.385 179.457C55.465 179.457 55.544 179.456 55.624 179.465C59.063 169.934 68.196 163.119 78.913 163.119C89.836 163.119 99.112 170.197 102.4 180.022C103.968 179.648 105.601 179.457 107.272 179.457C119.088 179.457 128.666 189.027 128.666 200.842Z",
    fill: "#00A656"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.666 200.842C128.666 212.658 119.088 222.237 107.272 222.237H55.385C43.578 222.237 34 212.658 34 200.842C34 189.027 43.578 179.457 55.385 179.457C55.465 179.457 55.544 179.456 55.624 179.465C59.063 169.934 68.196 163.119 78.913 163.119C89.836 163.119 99.112 170.197 102.4 180.022C103.968 179.648 105.601 179.457 107.272 179.457C119.088 179.457 128.666 189.027 128.666 200.842Z",
    stroke: "#00A656",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.578 251.671C386.578 266.126 374.86 277.846 360.405 277.846H296.924C282.478 277.846 270.76 266.126 270.76 251.671C270.76 237.216 282.478 225.508 296.924 225.508C297.021 225.508 297.118 225.508 297.216 225.518C301.424 213.859 312.597 205.52 325.708 205.52C339.072 205.52 350.42 214.179 354.442 226.199C356.361 225.741 358.359 225.508 360.405 225.508C374.86 225.508 386.578 237.216 386.578 251.671Z",
    fill: "#00A656"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.578 251.671C386.578 266.126 374.86 277.846 360.405 277.846H296.924C282.478 277.846 270.76 266.126 270.76 251.671C270.76 237.216 282.478 225.508 296.924 225.508C297.021 225.508 297.118 225.508 297.216 225.518C301.424 213.859 312.597 205.52 325.708 205.52C339.072 205.52 350.42 214.179 354.442 226.199C356.361 225.741 358.359 225.508 360.405 225.508C374.86 225.508 386.578 237.216 386.578 251.671Z",
    stroke: "#00A656",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.495499
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.652 249.284C327.353 249.284 327.923 248.715 327.923 248.013V229.707C327.923 229.006 327.353 228.436 326.652 228.436C325.95 228.436 325.381 229.006 325.381 229.707V248.013C325.381 248.715 325.95 249.284 326.652 249.284Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.3 231.313C337.796 230.817 337.796 230.012 337.3 229.516L327.552 219.767C327.056 219.271 326.251 219.271 325.755 219.767C325.259 220.263 325.259 221.069 325.755 221.565L335.502 231.313C335.998 231.809 336.804 231.809 337.3 231.313Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.552 219.767C327.056 219.271 326.25 219.271 325.754 219.767L316.007 229.515C315.511 230.011 315.511 230.817 316.007 231.313C316.503 231.809 317.308 231.809 317.804 231.313L327.552 221.565C328.048 221.069 328.048 220.263 327.552 219.767Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.037 252.024C328.037 252.777 327.427 253.386 326.674 253.386C325.922 253.386 325.311 252.777 325.311 252.024C325.311 251.272 325.922 250.662 326.674 250.662C327.427 250.662 328.037 251.272 328.037 252.024Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.637 256.128C327.637 256.66 327.204 257.092 326.672 257.092C326.14 257.092 325.709 256.66 325.709 256.128C325.709 255.596 326.14 255.164 326.672 255.164C327.204 255.164 327.637 255.596 327.637 256.128Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.246 259.228C327.246 259.543 326.99 259.8 326.674 259.8C326.358 259.8 326.102 259.543 326.102 259.228C326.102 258.913 326.358 258.656 326.674 258.656C326.99 258.656 327.246 258.913 327.246 259.228Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.384388
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.1882 197.092C79.6765 197.092 80.0736 196.695 80.0736 196.206V183.454C80.0736 182.965 79.6765 182.568 79.1882 182.568C78.6991 182.568 78.3027 182.965 78.3027 183.454V196.206C78.3027 196.695 78.6991 197.092 79.1882 197.092Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6045 184.572C86.95 184.226 86.95 183.666 86.6045 183.32L79.8137 176.529C79.4682 176.183 78.9074 176.183 78.5619 176.529C78.2164 176.874 78.2164 177.436 78.5619 177.781L85.3519 184.572C85.6975 184.917 86.2589 184.917 86.6045 184.572Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8135 176.529C79.4679 176.183 78.9064 176.183 78.5609 176.529L71.7709 183.319C71.4253 183.665 71.4253 184.226 71.7709 184.572C72.1164 184.917 72.6772 184.917 73.0227 184.572L79.8135 177.781C80.159 177.436 80.159 176.874 79.8135 176.529Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.151 199.002C80.151 199.526 79.726 199.95 79.2015 199.95C78.6776 199.95 78.252 199.526 78.252 199.002C78.252 198.478 78.6776 198.053 79.2015 198.053C79.726 198.053 80.151 198.478 80.151 199.002Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8724 201.859C79.8724 202.23 79.5708 202.531 79.2002 202.531C78.8295 202.531 78.5293 202.23 78.5293 201.859C78.5293 201.488 78.8295 201.188 79.2002 201.188C79.5708 201.188 79.8724 201.488 79.8724 201.859Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5997 204.018C79.5997 204.237 79.4213 204.416 79.2012 204.416C78.9811 204.416 78.8027 204.237 78.8027 204.018C78.8027 203.798 78.9811 203.619 79.2012 203.619C79.4213 203.619 79.5997 203.798 79.5997 204.018Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6496_24133"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 400,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFillesImage);
export default __webpack_public_path__ + "static/media/fillesImage.9a6b9997e52f4b9282f21bd4d1a94157.svg";
export { ForwardRef as ReactComponent };